'use client';
import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';
import { MyEquipmentHeader } from 'components/pcc-components';
import { useMyEquipmentDrawer } from '../my-equipment-drawer-context';
import { useFormContext } from 'react-hook-form';
import { useFeedback } from 'providers/feedback-provider';

export const EditEquipmentDrawerHeader = () => {
  const t = useTranslations();
  const {
    editEquipmentDrawer: { closeDrawer, isChild }
  } = useMyEquipmentDrawer();
  const { dismissFeedback } = useFeedback();
  const { clearErrors, reset } = useFormContext();

  const resetFormAndCloseDrawer = () => {
    dismissFeedback();
    reset();
    clearErrors();
    closeDrawer();
  };

  return (
    <MyEquipmentHeader
      variant={'title-sm'}
      className="d-flex"
      onBackButtonClick={isChild ? resetFormAndCloseDrawer : null}
    >
      <CatHeading variant="title-sm">{t('MEQ_EDIT_EQUIP')}</CatHeading>
    </MyEquipmentHeader>
  );
};
